import React from 'react';

interface PlatformFeeHoverProps {
  show: boolean;
}

export const PlatformFeeHover = ({ show }: PlatformFeeHoverProps) => (
  <span className={`hover-state ${show ? '' : 'hide'}`}>
    <span className="bold-800">Platform Fee:</span>
    <br />
    <span>
      Customers pay a flat monthly base fee and a flat monthly user fee
      based on the number of users in the plan. The fee covers the usage
      of the avochato platform and customer support.
    </span>
  </span>
);
